import * as React from 'react';
import {
  type ClientProps,
  ClientContext,
} from 'containers/client/ClientProvider';
import { SatisMeter } from 'lib/satismeter';
import { Appcues } from 'lib/appcues';
import { ChurnZero } from 'lib/churnzero';
import Analytics from 'lib/analytics';
import { Map } from 'immutable';

type OwnProps = {
  username: string,
  email: string,
  internal: boolean,
};
type ContextProps = {
  clientId: number,
  clientAccountId: number,
  clientName: string,
};
type Props = OwnProps & ContextProps;

export class UserSatisfactionUtils extends React.Component<Props> {
  async componentDidMount() {
    const {
      username,
      email,
      clientId,
      clientName,
      clientAccountId,
      page,
      internal,
    } = this.props;

    Analytics.pageview(page);

    if (!internal) {
      const [appcuesLoaded, satismeterLoaded, churnzeroLoaded] = [
        Appcues.load(),
        SatisMeter.load(),
        ChurnZero.load(),
      ];

      await appcuesLoaded;
      Appcues.identify(email, {
        name: username,
        email: email,
        clientId,
        clientName,
      });

      await satismeterLoaded;
      SatisMeter.showSurvey(this.props);

      await churnzeroLoaded;
      ChurnZero.identify({ email, accountId: clientAccountId });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.page !== prevProps.page) {
      if (!this.props.internal) {
        Appcues.page();
      }
      Analytics.pageview(this.props.page);
    }
  }

  componentWillUnmount() {
    ChurnZero.stop();
  }

  render() {
    return null;
  }
}

export class UserSatisfaction extends React.PureComponent<OwnProps> {
  render() {
    return (
      <ClientContext.Consumer>
        {(clientProps: ClientProps) => {
          if (!clientProps) return null;
          if (!Map.isMap(clientProps.properties)) return null;

          const clientId = clientProps.clientId;
          const clientList = Array.isArray(clientProps.clients)
            ? clientProps.clients
            : [];
          const currentClientInfo = clientList.find(
            client => client.merchant_group_id === clientId
          );
          const clientName = currentClientInfo
            ? currentClientInfo.merchant_group_name
            : null;

          const clientAccountId = clientProps.properties.get(
            'ss_account_information_id'
          );

          return clientName ? (
            <UserSatisfactionUtils
              {...this.props}
              clientId={clientId}
              clientName={clientName}
              clientAccountId={clientAccountId}
            />
          ) : null;
        }}
      </ClientContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/__components__/UserSatisfaction.js